import React from 'react';
import styled from 'styled-components';

import { DeleteXIcon } from '../../assets/icons/iconRepository';
import GlobalTheme from '../../styled/GlobalTheme';
import FormController from '../globals/FormController';
import Button from '../../components/buttons/Button';

export const CollaboratorsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const CollaboratorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CollaboratorFullName = styled.p`
  color: ${(props) => props.theme.colors.black3E};
  font-size: 18px;
  font-weight: 400;
`;

export const DeleteMemberButton = styled(Button)`
  && {
    background: ${(props) => props.theme.colors.badge};
    color: ${(props) => props.theme.colors.white};
    margin-bottom: 17px;
    height: 40px;
    font-size: 14px;
    white-space: nowrap;
  }

  ${GlobalTheme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

export const SaveMemberTouchable = styled.i`
  display: block;
  width: max-content;
  margin: 30px auto auto;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};

  opacity: ${(props) => (!props.disabled ? 1 : 0.6)};
  cursor: ${(props) => (!props.disabled ? 'pointer' : 'not-allowed')};

  &:hover {
    opacity: 0.6;
  }
`;

export const RestrictionName = styled.p`
  color: ${(props) => props.theme.colors.black3E};
  font-size: 14px;
  font-weight: 400;
`;

export const SocialBrandName = styled.p`
  color: ${(props) => props.theme.colors.black3E};
  font-size: 14px;
  font-weight: 400;
`;

export const CheckboxWrapper = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const CollapsedToggler = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 16.4992L4.5 8.99922L5.55 7.94922L12 14.3992L18.45 7.94922L19.5 8.99922L12 16.4992Z'
      fill='#909090'
    />
  </svg>
);

export const TinyLogos = {
  Facebook: (props) => (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.2386 2.00195C6.69861 2.00195 2.20703 6.47895 2.20703 12.001C2.20703 16.991 5.87494 21.1269 10.6715 21.8799V14.892H8.12324V12.001H10.6715V9.79795C10.6715 7.28995 12.1694 5.90695 14.4598 5.90695C15.5574 5.90695 16.7071 6.10195 16.7071 6.10195V8.56095H15.439C14.195 8.56095 13.8057 9.33295 13.8057 10.124V11.999H16.5857L16.1413 14.89H13.8057V21.878C18.6023 21.129 22.2702 16.992 22.2702 12.001C22.2702 6.47895 17.7786 2.00195 12.2386 2.00195Z'
        fill='#43629F'
      />
    </svg>
  ),
  Instagram: (props) => (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.8812 7.19249C10.2124 7.19249 8.05852 9.33937 8.05852 11.9995C8.05852 14.6597 10.2124 16.8066 12.8812 16.8066C15.55 16.8066 17.7039 14.6597 17.7039 11.9995C17.7039 9.33937 15.55 7.19249 12.8812 7.19249ZM12.8812 15.1237C11.1553 15.1237 9.74681 13.7198 9.74681 11.9995C9.74681 10.2792 11.1553 8.87531 12.8812 8.87531C14.6071 8.87531 16.0156 10.2792 16.0156 11.9995C16.0156 13.7198 14.6071 15.1237 12.8812 15.1237ZM17.9014 5.87531C17.2783 5.87531 16.7751 6.37687 16.7751 6.99796C16.7751 7.61906 17.2783 8.12062 17.9014 8.12062C18.5245 8.12062 19.0277 7.6214 19.0277 6.99796C19.0279 6.85048 18.9989 6.70441 18.9424 6.56812C18.8858 6.43183 18.8029 6.308 18.6982 6.20371C18.5936 6.09943 18.4694 6.01674 18.3327 5.96039C18.1959 5.90403 18.0494 5.87512 17.9014 5.87531ZM22.282 11.9995C22.282 10.7058 22.2938 9.42374 22.2209 8.13234C22.148 6.63234 21.8047 5.30109 20.7043 4.20421C19.6015 3.10499 18.2682 2.76515 16.7633 2.69249C15.4654 2.61984 14.1792 2.63156 12.8836 2.63156C11.5856 2.63156 10.2994 2.61984 9.00377 2.69249C7.49889 2.76515 6.1633 3.10734 5.06285 4.20421C3.96005 5.30343 3.6191 6.63234 3.54621 8.13234C3.47332 9.42609 3.48507 10.7081 3.48507 11.9995C3.48507 13.2909 3.47332 14.5753 3.54621 15.8667C3.6191 17.3667 3.96241 18.698 5.06285 19.7948C6.16565 20.8941 7.49889 21.2339 9.00377 21.3066C10.3017 21.3792 11.5879 21.3675 12.8836 21.3675C14.1815 21.3675 15.4677 21.3792 16.7633 21.3066C18.2682 21.2339 19.6038 20.8917 20.7043 19.7948C21.8071 18.6956 22.148 17.3667 22.2209 15.8667C22.2961 14.5753 22.282 13.2933 22.282 11.9995ZM20.2128 17.5261C20.0412 17.9526 19.8342 18.2714 19.5027 18.5995C19.1712 18.93 18.8537 19.1362 18.4258 19.3073C17.1889 19.7972 14.2521 19.687 12.8812 19.687C11.5103 19.687 8.57112 19.7972 7.33429 19.3097C6.90634 19.1386 6.58655 18.9323 6.25736 18.6019C5.92581 18.2714 5.71889 17.955 5.54724 17.5284C5.05815 16.2933 5.16867 13.3659 5.16867 11.9995C5.16867 10.6331 5.05815 7.70343 5.54724 6.47062C5.71889 6.04406 5.92581 5.72531 6.25736 5.39718C6.5889 5.06906 6.90634 4.86046 7.33429 4.68937C8.57112 4.20187 11.5103 4.31203 12.8812 4.31203C14.2521 4.31203 17.1913 4.20187 18.4281 4.68937C18.8561 4.86046 19.1759 5.06671 19.5051 5.39718C19.8366 5.72765 20.0435 6.04406 20.2152 6.47062C20.7043 7.70343 20.5937 10.6331 20.5937 11.9995C20.5937 13.3659 20.7043 16.2933 20.2128 17.5261Z'
        fill='#DC3275'
      />
    </svg>
  ),
  Linkedin: (props) => (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.18354 3H20.5743C21.3106 3 21.9102 3.58104 21.9102 4.29786V19.7012C21.9102 20.4179 21.3106 21 20.5743 21H5.18354C4.44871 21 3.85156 20.4179 3.85156 19.7012V4.29786C3.85156 3.58104 4.44871 3 5.18354 3ZM7.77909 5.4C8.61704 5.4 9.29733 6.07958 9.29733 6.9168C9.29733 7.75429 8.61704 8.43387 7.77909 8.43387C6.93781 8.43387 6.25938 7.75429 6.25938 6.9168C6.25938 6.07958 6.93781 5.4 7.77909 5.4ZM6.46743 18H9.08953V9.58375H6.46743V18ZM10.7328 9.58374H13.2438V10.7343H13.2797C13.629 10.0727 14.4837 9.37488 15.7581 9.37488C18.4104 9.37488 18.9005 11.1175 18.9005 13.3842V18H16.2813V13.9072C16.2813 12.9312 16.2645 11.6756 14.9202 11.6756C13.5572 11.6756 13.3492 12.7394 13.3492 13.8373V18H10.7328V9.58374Z'
        fill='#0E76A8'
      />
    </svg>
  ),
  Twitter: (props) => (
    <svg
      width={15}
      height={16}
      viewBox='0 0 22 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clip-path='url(#clip0_21752_3380)'>
        <path
          d='M0.0488889 0L8.54333 11.5871L0 21H1.91889L9.39889 12.7606L15.4489 21H22L13.0289 8.77059L20.9856 0H19.0667L12.1733 7.59706L6.6 0H0.0488889ZM2.87222 1.44529H5.87889L19.1522 19.5547H16.1456L2.88444 1.44529H2.87222Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_21752_3380'>
          <rect width='22' height='21' fill='white' />
        </clipPath>
      </defs>
    </svg>
  ),
};

export const SocialCheckboxesWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);

  ${GlobalTheme.breakpoints.down('sm')} {
    column-gap: 14px;
  }
`;

export const RestrictionsCheckboxesWrapper = styled.div`
  margin-top: 42px;
`;

export const SocialBusinessName = styled.p`
  color: ${(props) => props.theme.colors.black3E};
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SocialAndRestictionSubWrapper = styled.div`
  ${(props) =>
    !props.lastchild
      ? ''
      : `
        ${GlobalTheme.breakpoints.down('sm')} {
          margin-top: -30px;
        }
  `}
`;

export const SocialOrRestrictionTitle = styled.p`
  font-size: 20px;
  font-weight: 400;

  color: ${(props) => props.theme.colors.black3E};
`;

export const SocialAndRestrictionsWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 42px;

  ${GlobalTheme.breakpoints.down('sm')} {
    gap: 20px;
    flex-direction: column;
  }
`;

export const SocialWrapper = styled.div`
  width: 42%;
`;

export const RestrictionWrapper = styled.div`
  width: 42%;
`;

export const InputsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 22px;

  ${GlobalTheme.breakpoints.down('sm')} {
    flex-direction: column;
    gap: 0px;
  }
`;

export const Input = styled(FormController)`
  width: 28%;

  ${GlobalTheme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const CancelText = styled.i`
  width: max-content;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 0px;
  margin-bottom: 15px;
  gap: 6px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  align-items: center;
  opacity: ${(props) => (props.draft ? 0.25 : 1)};
  cursor: ${(props) => (props.draft ? 'not-allowed' : 'pointer')};
  color: ${(props) => props.theme.colors.black};
`;

export const CloseButton = styled.button`
  border: none;

  width: 24px;
  height: 24px;
  background-image: url(${DeleteXIcon});
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;

  cursor: ${(props) => (props.draft ? 'not-allowed' : 'pointer')};
`;

export const CollaboratorCollapsableHero = styled.div`
  padding: 25px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.primaryMoreLighter};
  cursor: ${(props) => (props.collapsable ? 'pointer' : 'default')};
`;
